export const REGISTER_INPUT_USERNAME = 'REGISTER/INPUT/USERNAME'
export const REGISTER_INPUT_EMAIL = 'REGISTER/INPUT/EMAIL'
export const REGISTER_INPUT_PASSWORD = 'REGISTER/INPUT/PASSWORD'
export const REGISTER_INPUT_REFFERAL_ID = 'REGISTER/INPUT/REFFERAL_ID'
export const REGISTER_INPUT_PHONE = 'REGISTER/INPUT/PHONE'

export const REGISTER_STATUS_WAITING = 'REGISTER/STATUS/WAITING'
export const REGISTER_STATUS_PROCESSING = 'REGISTER/STATUS/PROCESSING'
export const REGISTER_STATUS_SUCCESS = 'REGISTER/STATUS/SUCCESS'
export const REGISTER_STATUS_FAILED = 'REGISTER/STATUS/FAILED'

export const FETCH_REGISTER_TEXT_REQUEST = 'APP/SETTINGS/REGISTER_TEXT'

export const ERORR_PASSWORD = 'REGISTER/ERROR/PASSWORD'
export const ERORR_PHONE = 'REGISTER/ERROR/PHONE'
export const ERORR_USERNAME = 'REGISTER/ERROR/USERNAME'
export const ERORR_EMAIL = 'REGISTER/ERROR/EMAIL'
export const ERORR_REFFERAL_ID = 'REGISTER/ERROR/REFFERAL_ID'

export const DISABLE_REGISTER = 'REGISTER/DISABLE'
